module.exports = __webpack_public_path__ + "img/21-2e5dd44d.png";